import styled from '@emotion/styled';
import { css, keyframes } from 'emotion';

import { fadeIn } from '../styles/helpers';

const HEADER_OFFSET = 40;

const slideUp = keyframes`
  from {
    top: 100%;
    transform: translateY(0);
  }
  to {
    top: 0;
    transform: translateY(-100%);
  }
`;

export const AnimationWrapper = styled.div`
  position: absolute;
  flex-shrink: 0;
  width: 100%;
  display: flex;
  justify-content: flex-start;
  flex-flow: column nowrap;
  opacity: 0;

  will-change: transform;
  transform-style: preserve-3d;

  animation-name: ${slideUp}, ${fadeIn};
  animation-duration: var(--duration), 200ms;
  animation-timing-function: linear;
  animation-fill-mode: forwards;
`;

export const Container = styled.div`
  width: 100%;
  text-transform: none;
  display: flex;
  justify-content: center;
  flex-flow: row nowrap;
  font-weight: normal;
  text-shadow: 1px 1px 1px rgba(0, 0, 0, 0.6);
  font-size: 12px;
  position: relative;
  overflow: hidden;
  color: #dbdbdb;
  margin: 0 10px;

  mask-image: linear-gradient(
    to top,
    rgba(0 ,0, 0, 0) 0%,
    rgba(0, 0, 0 ,1) 20%,
    rgba(0, 0, 0, 1) 80%,
    rgba(0, 0, 0 ,0) 100%
  );
`;

export const rowClassName = css`
  padding: 2px;
  max-width: 100%;
  text-shadow: 1px 1px 1px rgba(0, 0, 0, 0.6);
  align-items: center;
  display: flex;

  > span:first-child {
    margin-right: 6px;
  }
`;

export const mobileRow = css`
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  grid-column-gap: 6px;

  > span {
    &:first-child {
      text-align: right;
      margin-right: 0;
    }

    &:nth-child(2) {
      text-align: left;
    }
  }
`;

export const desktopClassName = css`
  position: absolute;
  left: 0;
  top: 40px;
  height: calc(100% - ${HEADER_OFFSET}px);
  max-width: 300px;

  span {
    display: inline-block;
    &:first-child {
      max-width: 175px;
    }
  }
`;

export const mobileClassName = css`
  max-width: 60%;
  height: 100%;
  min-height: auto;
  margin: 12px 0 0 0;

  @media all and (orientation: landscape) {
    max-width: 30% !important;
    right: 10px;
    margin: 0;
    position: absolute !important;
  }

  ${AnimationWrapper} {
    justify-content: center;
  }
`;

export const overflowClassName = css`
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`;
